import { ShopOffersItem } from './shop-offers.model';

export class ShopOffersInventory {
  constructor(
    public Coins: ShopOffersItem[],
    public Gems: ShopOffersItem[]
  ) {}
}
